/*
  TCG CUSTOM ENGRAVING — ENGRAVING 2026-10-30
  1) Powers the PDP engraving card (snippets/tcg-engraving.liquid): open/close, live preview,
     input cleaning, submit validation, and property injection into secondary ATC forms
     (Falcon sticky ATC, Sapphire sticky bar).
  2) Keeps the hidden $15 "Custom Blade Engraving" fee product (variant 57746036359494) in sync
     with the number of engraved blades in the cart, via the theme's cart-component element.
     A knife line with a Logo property counts twice (text/icons $15 + logo $15).
     Bundle lines carry properties[_knives]: $15 per blade.
     Lines bought as an "Engraving" variant (Text & icons / With logo) already include the price: no fee.
  3) Cart drawer: "Edit engraving" link on designer lines + free-engraving progress note,
     or a Personalised Gifts notice when nothing in the cart is engraved yet.
  4) Personalised Gifts collection page: filter tabs (All / Single knives / Gift sets / Bestsellers).
  Loaded globally from layout/theme.liquid (defer).
*/
(function () {
  'use strict';

  var FEE_VARIANT = 57746036359494;
  var MAX_LEN = 20;

  /* ---------------- PDP card ---------------- */

  function activeCard() {
    var card = document.querySelector('.tcg-eng');
    if (!card) return null;
    var toggle = card.querySelector('.tcg-eng-toggle');
    if (!toggle || !toggle.checked) return null;
    return card;
  }

  function cardValues(card) {
    var text = card.querySelector('.tcg-eng-text');
    var font = card.querySelector('.tcg-eng-font input:checked');
    var kn = card.querySelector('.tcg-eng-extra');
    return {
      text: text ? text.value.trim() : '',
      font: font ? font.value : 'Classic Block',
      knives: kn ? kn.value : ''
    };
  }

  function showError(card) {
    var err = card.querySelector('.tcg-eng-error');
    var text = card.querySelector('.tcg-eng-text');
    if (err) err.hidden = false;
    if (text) text.focus();
    if (card.scrollIntoView) card.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function clean(v) {
    return v.replace(/[^A-Za-z0-9 .,'&\-]/g, '').replace(/\s{2,}/g, ' ').slice(0, MAX_LEN);
  }

  function initCards() {
    document.querySelectorAll('.tcg-eng:not([data-tcg-init])').forEach(function (card) {
      card.setAttribute('data-tcg-init', '1');

      var toggle = card.querySelector('.tcg-eng-toggle');
      var body = card.querySelector('.tcg-eng-body');
      var text = card.querySelector('.tcg-eng-text');
      var counter = card.querySelector('.tcg-eng-count');
      var preview = card.querySelector('.tcg-eng-preview-text');
      var err = card.querySelector('.tcg-eng-error');
      var fonts = card.querySelectorAll('.tcg-eng-font input');

      function setOpen(on) {
        if (text) text.disabled = !on;
        fonts.forEach(function (f) { f.disabled = !on; });
        card.querySelectorAll('.tcg-eng-extra').forEach(function (f) { f.disabled = !on; });
        if (body) body.hidden = !on;
        card.classList.toggle('open', on);
        if (!on && err) err.hidden = true;
        if (on && text) text.focus();
      }

      function render() {
        if (!text) return;
        var v = clean(text.value);
        if (v !== text.value) text.value = v;
        if (counter) counter.textContent = v.length + '/' + MAX_LEN;
        if (preview) {
          preview.textContent = v || 'Your Text';
          var f = card.querySelector('.tcg-eng-font input:checked');
          preview.classList.toggle('script', !!(f && f.value === 'Elegant Script'));
          preview.classList.toggle('block', !(f && f.value === 'Elegant Script'));
        }
        if (v.length && err) err.hidden = true;
      }

      if (toggle) toggle.addEventListener('change', function () { setOpen(toggle.checked); });
      if (text) text.addEventListener('input', render);
      fonts.forEach(function (f) { f.addEventListener('change', render); });
      card.querySelectorAll('.tcg-eng-chip').forEach(function (chip) {
        chip.addEventListener('click', function () {
          if (!text) return;
          text.value = chip.textContent.trim();
          render();
          text.focus();
        });
      });
      render();

      // Validate the main product form (the card sits inside it).
      var form = card.closest('form');
      if (form) {
        form.addEventListener('submit', function (e) {
          if (toggle && toggle.checked && text && !text.value.trim()) {
            e.preventDefault();
            e.stopImmediatePropagation();
            showError(card);
          }
        }, true);
      }
    });

    initSecondaryForms();
    initSapphireSticky();
  }

  // Falcon sticky ATC (and any other product form on the page that is NOT the one
  // holding the card): inject the engraving properties on submit so they are not lost.
  function initSecondaryForms() {
    document.querySelectorAll('form[action*="/cart/add"]:not([data-tcg-eng-watch])').forEach(function (form) {
      form.setAttribute('data-tcg-eng-watch', '1');
      form.addEventListener('submit', function (e) {
        var card = activeCard();
        if (!card) return;
        if (form.contains(card)) return; // main form handles itself
        var vals = cardValues(card);
        if (!vals.text) {
          e.preventDefault();
          e.stopImmediatePropagation();
          showError(card);
          return;
        }
        setHidden(form, 'properties[Engraving]', vals.text);
        setHidden(form, 'properties[Font]', vals.font);
        if (vals.knives) setHidden(form, 'properties[_knives]', vals.knives);
      }, true);
    });
  }

  function setHidden(form, name, value) {
    var input = form.querySelector('input[name="' + CSS.escape(name) + '"][data-tcg-eng]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.setAttribute('data-tcg-eng', '1');
      form.appendChild(input);
    }
    input.value = value;
  }

  // Sapphire PDP sticky bar uses a GET /cart/add link, which cannot carry properties.
  function initSapphireSticky() {
    document.querySelectorAll('.ff-sticky .cta:not([data-tcg-eng-watch])').forEach(function (a) {
      a.setAttribute('data-tcg-eng-watch', '1');
      a.addEventListener('click', function (e) {
        var card = activeCard();
        if (!card) return;
        var vals = cardValues(card);
        if (!vals.text) {
          e.preventDefault();
          showError(card);
          return;
        }
        var m = (a.getAttribute('href') || '').match(/id=(\d+)/);
        if (!m) return;
        e.preventDefault();
        var payload = {
          items: [{ id: Number(m[1]), quantity: 1, properties: { Engraving: vals.text, Font: vals.font } }]
        };
        if (vals.knives) payload.items[0].properties._knives = vals.knives;
        var cc = document.querySelector('cart-component');
        if (cc && cc.add) {
          cc.add(payload);
        } else {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
          }).then(function () { window.location.href = '/?cart=true'; });
        }
      }, true);
    });
  }

  /* ---------------- Cart fee sync ---------------- */

  var syncing = false;
  var syncTimer = null;

  function scheduleSync() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(sync, 400);
  }

  // Lines bought as an Engraving variant already include the engraving price: no fee line for them.
  function isEngVariant(i) {
    return (i.options_with_values || []).some(function (o) { return o.name === 'Engraving' && o.value !== 'None'; });
  }

  function sync() {
    if (syncing) return;
    var cc = document.querySelector('cart-component');
    if (!cc || !cc.get) return;
    syncing = true;
    cc.get().then(function (cart) {
      var feeLine = null;
      var engraved = 0;
      cart.items.forEach(function (i) {
        if (Number(i.variant_id) === FEE_VARIANT) {
          feeLine = i;
        } else if (i.properties && i.properties['Engraving'] && !isEngVariant(i)) {
          var kn = Math.max(1, Number(i.properties['_knives']) || 1); // bundles: $15 per blade
          engraved += i.quantity * kn;
          if (i.properties['Logo']) engraved += i.quantity; // logo engraving = second $15 per knife
        }
      });
      var feeQty = feeLine ? feeLine.quantity : 0;
      if (engraved === feeQty) return null;
      if (engraved === 0 && feeLine) return cc.change(feeLine.key, 0);
      if (feeLine) return cc.change(feeLine.key, engraved);
      return cc.add({ items: [{ id: FEE_VARIANT, quantity: engraved, properties: { _tcg_engraving_fee: 'yes' } }] });
    }).catch(function () { /* never break the cart */ }).finally(function () {
      syncing = false;
    });
  }

  window.addEventListener('cart:added', function () { if (!syncing) scheduleSync(); });
  window.addEventListener('cart:changed', function () { if (!syncing) scheduleSync(); });
  /* ---------- Cart drawer: Edit engraving links + free-engraving progress ---------- */
  function decorateCart() {
    var cc = document.querySelector('cart-component');
    if (!cc || !cc.get) return;
    cc.get().then(function (cart) {
      var fee = 0, sub = 0, engraved = false, logo = false, items = 0;
      cart.items.forEach(function (i) {
        if (Number(i.variant_id) === FEE_VARIANT) { fee += i.original_line_price; return; }
        sub += i.final_line_price; items++;
        if (i.properties && i.properties.Engraving && !i.properties._engrave) engraved = true;
        if (!i.properties || !i.properties._engrave) return;
        engraved = true;
        if (i.properties.Logo) logo = true;
        var li = document.querySelector('.cart-item[data-line-item-key="' + i.key + '"]');
        if (li) li.querySelectorAll('.cart-item-variant-change-btn').forEach(function (b) { b.remove(); });
        if (!li || li.querySelector('.tcgx-cart-edit')) return;
        var a = document.createElement('a');
        a.className = 'tcgx-cart-edit';
        a.href = i.url + (i.url.indexOf('?') > -1 ? '&' : '?') + 'tcgx_edit=' + encodeURIComponent(i.key);
        a.textContent = '✎ Edit engraving';
        a.style.cssText = 'display:inline-block;margin-top:6px;border:1px solid #e4e4e7;border-radius:999px;padding:3px 10px;font-size:11px;font-weight:700;text-decoration:none;color:#020617';
        var anchor = li.querySelector('.cart-item-properties') || li.querySelector('.cart-item-title');
        if (anchor) anchor.insertAdjacentElement('afterend', a);
      });
      var old = document.querySelector('.tcgx-cart-prog');
      if (old) old.remove();
      var list = cc.querySelector('.cart-items');
      if (!engraved) {
        /* Personalised Gifts notice for carts with no engraving yet */
        if (!items || !list) return;
        var promo = document.createElement('a');
        promo.className = 'tcgx-cart-prog tcgx-cart-promo';
        promo.href = '/collections/personalised-gifts';
        promo.style.cssText = 'display:flex;align-items:center;gap:10px;margin:0 0 10px;padding:10px 12px;border-radius:8px;background:#14110b;color:#f3dca6;font-size:12px;line-height:1.35;text-decoration:none';
        promo.innerHTML = '<span style="font-size:18px;line-height:1">✎</span><span><b style="color:#fff">New: Personalised Gifts.</b> Laser engrave a name or message on any Dynasty or Sapphire knife from $15.</span><span style="margin-left:auto;white-space:nowrap;font-weight:700;text-decoration:underline">Shop</span>';
        list.insertAdjacentElement('beforebegin', promo);
        return;
      }
      var FREE = 19900, gap = FREE - sub, what = logo ? 'text engraving' : 'engraving';
      var box = document.createElement('div');
      box.className = 'tcgx-cart-prog';
      box.style.cssText = 'margin:0 0 10px;padding:9px 11px;border-radius:8px;background:#f5f6f8;font-size:12px;line-height:1.4';
      box.innerHTML = gap > 0
        ? 'Add <b>$' + (gap / 100).toFixed(2) + '</b> more and your ' + what + ' is <b>FREE</b><div style="height:5px;border-radius:9px;background:#e4e6ea;margin-top:6px;overflow:hidden"><i style="display:block;height:100%;background:#1f7a43;width:' + Math.min(100, sub / FREE * 100) + '%"></i></div>'
        : '🎉 Your ' + what + ' is <b>FREE</b> on this order' + (logo ? ' (logo add-on $15)' : '');
      if (list) list.insertAdjacentElement('beforebegin', box);
    }).catch(function () {});
  }

  window.addEventListener('cart:rendered', function () { initCards(); setTimeout(decorateCart, 50); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initCards(); scheduleSync(); setTimeout(decorateCart, 600); });
  } else {
    initCards();
    scheduleSync();
  }
  setTimeout(decorateCart, 600);

  /* ---------- Personalised Gifts collection: All / Single knives / Gift sets / Bestsellers tabs ---------- */
  function pzTabs() {
    if (!/^\/collections\/personalised-gifts\/?$/.test(location.pathname)) return;
    if (document.querySelector('.tcg-pz-tabs')) return;
    var cards = [].slice.call(document.querySelectorAll('.product-card[data-pz-kind]'));
    if (!cards.length) return;
    var items = cards.map(function (c) { return c.parentElement && c.parentElement.children.length === 1 ? c.parentElement : c; });
    var grid = items[0].parentElement;
    var TABS = [['all', 'All'], ['single', 'Single knives'], ['set', 'Gift sets'], ['best', 'Bestsellers']];
    var bar = document.createElement('div');
    bar.className = 'tcg-pz-tabs';
    bar.setAttribute('role', 'tablist');
    bar.style.cssText = 'display:flex;gap:8px;overflow-x:auto;-webkit-overflow-scrolling:touch;scrollbar-width:none;margin:0 0 16px;padding:2px 0';
    TABS.forEach(function (t) {
      var b = document.createElement('button');
      b.type = 'button'; b.setAttribute('role', 'tab'); b.dataset.tab = t[0]; b.textContent = t[1];
      b.style.cssText = 'flex:0 0 auto;border:1px solid #d6cbb8;border-radius:999px;padding:8px 16px;font-size:13px;font-weight:700;line-height:1;cursor:pointer;white-space:nowrap;background:#fff;color:#14110b';
      bar.appendChild(b);
    });
    grid.parentElement.insertBefore(bar, grid);
    function show(tab) {
      items.forEach(function (el, i) {
        var kind = cards[i].getAttribute('data-pz-kind');
        var on = tab === 'all' || tab === 'best' || kind === tab; /* Bestsellers = everything, knives and sets, in best-selling order */
        el.style.display = on ? '' : 'none';
      });
      [].forEach.call(bar.children, function (b) {
        var a = b.dataset.tab === tab;
        b.setAttribute('aria-selected', a);
        b.style.background = a ? '#14110b' : '#fff';
        b.style.color = a ? '#f3dca6' : '#14110b';
        b.style.borderColor = a ? '#14110b' : '#d6cbb8';
      });
      try { var q = location.search.replace(/([?&])tab=[^&]*&?/, '$1').replace(/[?&]$/, ''); history.replaceState(null, '', location.pathname + q + (tab === 'all' ? '' : (q ? '&' : '?') + 'tab=' + tab)); } catch (e) {}
    }
    bar.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-tab]'); if (!b) return;
      var tab = b.dataset.tab;
      if (tab === 'best' && !/sort_by=best-selling/.test(location.search)) { location.href = location.pathname + '?sort_by=best-selling&tab=best'; return; }
      show(tab);
    });
    var m = location.search.match(/[?&]tab=(single|set|best)/);
    show(m ? m[1] : 'all');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pzTabs); else pzTabs();
})();
